import { ListMetadata } from './../../models/list-metadata.model';
import { Observable } from 'rxjs/Observable';
import { HttpClientService } from './../httpClient/httpclient.service';
import { Injectable } from '@angular/core';


@Injectable()
export class CampaignClusterheadService {

  constructor(private http: HttpClientService) { }

  /**
   * Restituisce la lista dei Clusterhead
   */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged('koncentro-loyalty/cluster/campaign/cluster-head-list?' + params.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/campaign-2.0/campaign-clusterhead.service.ts